import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/metaPixel";

/**
 * The pixel snippet in public/index.html fires PageView once, on the initial
 * document load. Every navigation after that is client side, so Meta never
 * sees it and any "URL contains ..." rule in Ads Manager silently never fires.
 *
 * This sends a PageView on each route change (skipping the very first render,
 * which the snippet already covered) so URL based targeting works.
 */
const MetaPixelRouteTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelRouteTracker;
